import { z } from "zod/v4";

export const FileUIPartSchema = z.object({
  type: z.literal("file"),
  mediaType: z.string(),
  fileName: z.string().optional(),
  url: z.string(),
});

export type FileUIPartType = z.infer<typeof FileUIPartSchema>;
